import './header.scss'
import { AppHeader, Avatar } from '@nike/eds'
import { useOktaAuth } from '@okta/okta-react'
import { useMemo } from 'react'
import { Text, Spinner } from '@nike/eds'
import { UserSettingsMenu } from './UserSettingsMenu'
import { useUserSettings } from '../UserSettingsProvider'
import { Link } from 'react-router-dom'

export function Header({ isDark }: { isDark: boolean }) {
    // Always rely on Okta React context (Security is now always mounted).
    const { oktaAuth, authState } = useOktaAuth();
    const { user, currentTerritories, setCurrentTerritories, availableTerritories, loading } = useUserSettings();
    const initials = useMemo(() => {
        const name = user?.name || authState?.accessToken?.claims?.sub || 'User';
        return name ? getInitials(name) : '-';
    }, [user, authState]);
    const isUserDataLoading = loading || authState?.isPending;
    const locationMatch = window.location.hostname.match(/^web-(?<region>[a-z0-9-]+)-(?<environment>[^.]+)\.(?<hostedZone>.+)$/);

    const ENV_INFO = locationMatch
      ? {
          region: locationMatch.groups?.region,
          environment: locationMatch.groups?.environment,
          hostedZone: locationMatch.groups?.hostedZone,
        }
      : undefined;

    const appName = `Customs Compliance Hub${ENV_INFO ? ` - ${ENV_INFO.environment}` : ''}`;

    return (
        <AppHeader
            className='eds-elevation--1'
            appName={<Link to="/exceptions"><Text className="app-header-app-name" font="display-4">{appName} </Text></Link>}
            isDark={isDark}
            avatarSlot={
                isUserDataLoading ? (
                    <div className="eds-flex eds-flex--align-items-center eds-flex--justify-content-center" style={{ width: 36, height: 36 }}>
                        <Spinner data-testid="spinner" />
                    </div>
                ) : (
                    <UserSettingsMenu
                        currentTerritories={currentTerritories}
                        setCurrentTerritories={setCurrentTerritories}
                        availableTerritories={availableTerritories}
                        user={user}
                        oktaAuth={oktaAuth}
                    >
                        <Avatar initials={initials} size={36} url={user?.avatarUrl || ""} />
                    </UserSettingsMenu>
                )
            }
        />
    )
}

function getInitials(name: string | undefined) {
    if (!name) return '-';
    const matchedFirstLetters = name.match(/(\b[A-Z])/g)
    if (!matchedFirstLetters || matchedFirstLetters.length < 2) {
        // Fallback: take first letter
        return name[0]?.toUpperCase()
    }
    return matchedFirstLetters.join('')
}
